import { PencilIcon } from '@buffer-mono/popcorn'

import { NewPostComposerTrigger } from '~publish/components/NewPostComposerTrigger'

import { TaskCard } from './TaskCard'
import { useHasCreatedPost } from './useHasCreatedPost'
import { BUFFER_HOME_TASK_STATUS } from './useBufferHomeChecklist'
import { useCreateFirstPostStatus } from './useTaskCardStatus'

import type { JSX } from 'react'

const CTA = 'publish-home-firstSteps-createFirstPost-1'

export function CreateFirstPostCard(): JSX.Element {
  const { status, markComplete } = useCreateFirstPostStatus()
  const { hasCreatedPost, loading } = useHasCreatedPost()
  // Once the task is server-completed, leave the button alone — disabling only
  // gates the pending → complete transition.
  const isPending = status === BUFFER_HOME_TASK_STATUS.Pending
  const canMarkComplete = !isPending || (!loading && hasCreatedPost)

  return (
    <TaskCard status={status}>
      <TaskCard.CompleteAction
        onClick={markComplete}
        disabled={!canMarkComplete}
        disabledReason="Schedule a post to mark this done"
      />
      <TaskCard.Header>
        <TaskCard.Title>2. Create a post</TaskCard.Title>
      </TaskCard.Header>
      <TaskCard.Description>
        Schedule your first post in just a few clicks.
      </TaskCard.Description>
      <TaskCard.Footer>
        <NewPostComposerTrigger cta={CTA}>
          <TaskCard.PrimaryAction>
            <PencilIcon />
            Create Post
          </TaskCard.PrimaryAction>
        </NewPostComposerTrigger>
        <TaskCard.CompletedLabel>First Post Created</TaskCard.CompletedLabel>
      </TaskCard.Footer>
    </TaskCard>
  )
}
